export const GET_EVOLUTION_MEASURE_WATCHER =
  "app/WidgetResume/GET_EVOLUTION_MEASURE_WATCHER"
export const GET_EVOLUTION_MEASURE_SUCCESS =
  "app/WidgetResume/GET_EVOLUTION_MEASURE_SUCCESS"
export const GET_EVOLUTION_MEASURE_FAILED =
  "app/WidgetResume/GET_EVOLUTION_MEASURE_FAILED"
